// extracted by mini-css-extract-plugin
export var actionText = "_qy-4";
export var container = "_qy-0";
export var leftSection = "_qy-1";
export var rightSection = "_qy-2";
export var settingsButton = "_qy-6";
export var settingsIcon = "_qy-7";
export var shortcut = "_qy-5";
export var shortcutGroup = "_qy-3";